import React from "react";
import { Route, useLocation } from "react-router-dom";
import Three0One from "../components/301";
import Four0Four from "../components/404";
import useNormalizedURI from "../hooks/useNormalizedURI";

const NormalizedRoute = () => {
  const currentUrl = useLocation().pathname;
  const normalizedUrl = useNormalizedURI().pathname();

  return currentUrl !== normalizedUrl ? (
    <Three0One to={normalizedUrl} from={currentUrl} />
  ) : (
    <Route exact path="*" component={Four0Four} />
  );
};

export default NormalizedRoute;
